import {Injectable} from "@angular/core";
import {map, Observable, of} from "rxjs";
import {ApiService} from '@core/services/api.service';
import {
  IBusinessExportDataSetting,
  IGoogleSheetAccessToken,
  IParamsDeleteSettingColumn,
  IParamsExportGoogleSheet,
  IParamsGenerateAuthURL,
  IParamsLoadSettingExportData,
  IParamsLoadSpreadSheets,
  IParamsRevokeToken,
  IParamsSaveSettingExportDataColumns,
  IResultExportGoogleSheet
} from '@shared/models/business';
import {IResponseApi, ISelectOption, V2ApiResponseError} from '@core/models';
import {uriConsts} from '@shared/constants';


type IResMesRecord = Record<string | 'unknown' | 'invalidGrant', any>


/**
 * Service xử lý dữ liệu Google Sheet
 * @author admin
 * */
@Injectable({
  providedIn: 'any'
})
export class GoogleSheetService extends ApiService {

  exportData(params: IParamsExportGoogleSheet) {
    return this.postJsonRequest<IResponseApi<IResultExportGoogleSheet>>(
      uriConsts.business.GOOGLE_SHEET_EXPORT, params
    ).pipe(map(res => {
      const spread = res?.data?.spreadData;
      if (res?.version !== '2.0' || res.code !== 1 || !spread ||
        typeof spread.spreadId !== 'string' || !spread.spreadId ||
        typeof spread.spreadUrl !== 'string' || !spread.spreadUrl ||
        !Number.isInteger(spread.spreadSheetId) || spread.spreadSheetId < 0 ||
        typeof spread.spreadSheetTitle !== 'string' || !spread.spreadSheetTitle ||
        !Number.isInteger(res.data.rowsWritten) ||
        res.data.rowsWritten !== params.rows.length) {
        // Lỗi HTTP đã normalize cũng phải dừng export, kể cả khi thiếu version.
        throw new V2ApiResponseError({
          ...res,
          code: 0,
          errorCode: res?.errorCode ?? null,
          messages: res?.code === 0 ? res.messages : ['common.messages.invalidData'],
          data: {totalPages: 0, totalItems: 0, page: 0, result: []}
        });
      }
      return res;
    }));
  }

  /**
   *
   * */
  generateAuthURL(params: IParamsGenerateAuthURL) {
    return this.postRequest<IResponseApi<string>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_GENERATE_AUTH_URL, params
    );
  }


  /**
   *
   * */
  loadAccessTokens(businessId: number) {
    // TODO: Bỏ comment khi BE làm xong API googlesheetload để tránh lỗi 404
    return of({code: 1, data: []}) as unknown as Observable<IResponseApi<IGoogleSheetAccessToken[]>>;
    /*
    return this.postRequest<IResponseApi<IGoogleSheetAccessToken[]>>(
    uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=loadAccessTokens`, {
    tab: 'loadAccessTokens',
    businessId
    }
    );
    */
  }

  /**
   *
   * */
  revokeAccessToken(params: IParamsRevokeToken) {
    return this.postRequest<IResponseApi>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=revokeAccessToken`, {
        tab: 'revokeAccessToken',
        ...params
      }
    );
  }

  /**
   *
   * */
  loadSettingColumns(params: IParamsLoadSettingExportData) {
    // TODO: Bỏ comment khi BE làm xong API googlesheetload để tránh lỗi 404
    return of({code: 1, data: []}) as unknown as Observable<IResponseApi<IBusinessExportDataSetting[]>>;
    /*
    return this.postRequest<IResponseApi<IBusinessExportDataSetting[]>>(
    uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=loadSettingColumns`, {
    tab: 'loadSettingColumns',
    ...params
    }
    );
    */
  }

  /**
   *
   * */
  saveSettingColumn(params: IParamsSaveSettingExportDataColumns) {
    return this.postRequest<IResponseApi<IBusinessExportDataSetting, IResMesRecord>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=saveSettingColumn`, {
        tab: 'saveSettingColumn',
        ...params,
        columns: JSON.stringify(params.columns),
        configs: JSON.stringify(params.configs)
      }
    );
  }

  /**
   *
   * */
  deleteSettingColumn(params: IParamsDeleteSettingColumn) {
    return this.postRequest<IResponseApi>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=deleteSettingColumn`, {
        tab: 'deleteSettingColumn',
        ...params
      }
    );
  }


  /**
   * - Func kiểm tra xem file có tồn tại không, nếu có thì trả về kèm sheet
   *
   * + Kiểm tra file google sheet của user có hợp lệ không
   * + Nếu hợp lệ thì trả về sheets trong file
   */
  checkSpreadId(params: IParamsLoadSpreadSheets) {
    return this.postRequest<IResponseApi<{
      spreadId: string,
      sheets: ISelectOption[]
    }, Record<string, any>>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=checkSpreadId`, {
        tab: 'checkSpreadId',
        ...params
      }
    );
  }

  checkSpreadDataImport(params: any) {
    return this.postRequest<IResponseApi<{
      spreadId: string,
      totalItems: number,
      totalPages: number,
      headersFinal: Record<string, string>
    }, Record<string, any>>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=checkSpreadDataImport`, {
        tab: 'checkSpreadDataImport',
        ...params
      }
    );
  }

}
